"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _GetRandomColor = require("./GetRandomColor");
Object.keys(_GetRandomColor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GetRandomColor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _GetRandomColor[key];
    }
  });
});